import { helper } from '@ember/component/helper';
import externalIdentityProviderLabelUtil from 'cio/utils/external-identity-provider-label';
import { IdentityProvider } from 'cio/models/sso-configuration';

export function externalIdentityProviderLabel([identityProvider]: [IdentityProvider]) {
  return externalIdentityProviderLabelUtil(identityProvider);
}

export default helper(externalIdentityProviderLabel);
